import { addMinutes, isAfter, isEqual } from "date-fns";
// helpers
import { checkIsItInFuture } from "../checkIsItInFuture";
import { getExactTime } from "../getExactTime";

export const checkIsItInFutureWithLimit = (
  date: Date,
  hours: number,
  minutes: number,
  seconds: number,
  limitInMinutes: number
): boolean => {
  // First, run the existing validation to check if the time is in the future
  const baseCheck = checkIsItInFuture(date, hours, minutes, seconds);
  if (!baseCheck) return false;

  // Create the exact selected datetime
  const selectedDateTime = getExactTime(date, hours, minutes, seconds);

  // Calculate the minimum allowed time (current time + limit)
  const minAllowedTime = addMinutes(new Date(), limitInMinutes);

  // Allow selected time if it is strictly after OR exactly equal to the minimum time
  return isAfter(selectedDateTime, minAllowedTime) || isEqual(selectedDateTime, minAllowedTime);
};
